import { MODULE_ID } from './constants';
export const PATIENT_SETUP = `${MODULE_ID}/PATIENT_SETUP`;
export const PATIENT_SETUP_SUCCESS = `${MODULE_ID}/PATIENT_SETUP_SUCCESS`;
export const PATIENT_SETUP_ERROR = `${MODULE_ID}/PATIENT_SETUP_ERROR`;
